import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface PersonUpsertState extends ApiState {
  personId?: string
}

export default requestReducer<PersonUpsertState>('PERSON_UPSERT')
